export const echatConfig = () => {
  console.log(process.env.VUE_APP_ENV)
  const env = process.env.VUE_APP_ENV
  // if (env !== 'prod') {
  //   return {
  //     key: 'NGVhYzVmNDVmMzllNDg1NWEyY2M0YWQ5YzY1OWU2N2E',
  //     appid: '4A34605DEA8CF39CF992FD911A0CEB85',
  //     companyId: '533109'
  //   }
  // }
  return {
    key: 'M2Y2ZGZjOTkyMWIyNGYzNjlhOTNmZGU3M2E1ZGE4YWM',
    appid: '117081BF84079DE8244D1368AE578F9D',
    companyId: '533043'
  }
}
